import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './XLcontact.css';
import { supportMail } from '../App';

const XLcontact: React.FC = () => {
  return (
    <div className="xl-contact-container">
      <Header />

      <section className="xl-contact-hero">
        <div className="xl-hero-inner">
          <h1 className="xl-hero-title">欢迎来到我们的AI生产力平台</h1>
          <p className="xl-hero-text">
            我们致力于提供创新的生产力解决方案，帮助您轻松提升效率和质量。了解更多关于我们的服务和产品，尽在这里。
          </p>
        </div>
      </section>

      <section className="xl-contact-section">
        <div className="xl-contact-inner">
          <div className="xl-contact-map">
            <img
              src={`${process.env.PUBLIC_URL}/image/xl-location-20260601.png`}
              alt="地图"
              className="xl-map-image"
            />
          </div>

          <div className="xl-contact-info">
            <h2 className="xl-contact-title">联系我们</h2>
            <p className="xl-contact-desc">
              欢迎随时与我们联系，我们的团队将竭诚为您服务。
            </p>
            <div className="xl-contact-details">
              <div className="xl-contact-item">
                <span className="xl-contact-icon">✉️</span>
                <span className="xl-contact-text">{supportMail}</span>
              </div>
              <div className="xl-contact-item">
                <span className="xl-contact-icon">📍</span>
                <span className="xl-contact-text">浙江省杭州市滨江区西兴街道聚园路8号A幢415室</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl-contact-cta">
        <div className="xl-cta-inner">
          <h2 className="xl-cta-title">立即联系我们，获取更多信息</h2>
          <p className="xl-cta-text">
            欢迎来到我们的网站！如需了解更多的产品或有任何问题，欢迎随时通过在线或电子邮件联系。我们期待与您沟通，共同探讨如何为您的业务提供最佳解决方案。
          </p>
          <div className="xl-cta-buttons">
            <a href={`mailto:${supportMail}`} className="xl-cta-btn">发送邮件</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default XLcontact;
